import { actionKitImpFunction } from '../../components/ozmoit/common';
import { getSections, getSectionsForm } from './api';

export const getSectionsFormAction = actionKitImpFunction(getSectionsForm);

export const getSectionsAction = actionKitImpFunction(getSections);
